// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerWrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 1cm;
    padding-bottom: 0.6cm;
    margin: 0 1.6cm 0 1.6cm;
    position: relative;
}

.headerWrapper:nth-child(1){
    border-bottom: 5px solid var(--psyellow)
}

.heading {
    width: 8.6cm;
    position: absolute;
    top: 70px;
    left: calc(50% - 4.3cm);
    text-align: center;
}

.heading>.section-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.meetingId {
    display: block;
    text-align: end;
}

.meetingIdWrapper, .meetingIdWrapper>* {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    position: relative;
    right: 0;
}
.meetingIdInputField {
    min-width: 10px;
    cursor: text;
    border: 1px solid transparent;
}

.meetingIdInputField[contenteditable]:empty::before {
    content: "ID";
    color: grey;
}

.logoWrapper {
    align-items: flex-end;
}
.headerLogo {
    height: 2.8cm;
    display: flex;
}
.footerLogo {
    height: 2cm;
    margin-right: 1cm;
}
.logoWrapper img {
   height: 100%;
}
.logoWrapper > img:nth-child(2){
    height: 2.5cm;
}

.topSeparator {
    border-top: 5px solid var(--psyellow);
    height: 5px;
    width: 17.8cm;
    position: absolute;
    margin-top: -1cm;
    /* top: 34.7cm; */
    z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/valuation/header/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,aAAa;AACjB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;GACG,YAAY;AACf;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".headerWrapper {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 1cm;\n    padding-bottom: 0.6cm;\n    margin: 0 1.6cm 0 1.6cm;\n    position: relative;\n}\n\n.headerWrapper:nth-child(1){\n    border-bottom: 5px solid var(--psyellow)\n}\n\n.heading {\n    width: 8.6cm;\n    position: absolute;\n    top: 70px;\n    left: calc(50% - 4.3cm);\n    text-align: center;\n}\n\n.heading>.section-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.meetingId {\n    display: block;\n    text-align: end;\n}\n\n.meetingIdWrapper, .meetingIdWrapper>* {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: row;\n    position: relative;\n    right: 0;\n}\n.meetingIdInputField {\n    min-width: 10px;\n    cursor: text;\n    border: 1px solid transparent;\n}\n\n.meetingIdInputField[contenteditable]:empty::before {\n    content: \"ID\";\n    color: grey;\n}\n\n.logoWrapper {\n    align-items: flex-end;\n}\n.headerLogo {\n    height: 2.8cm;\n    display: flex;\n}\n.footerLogo {\n    height: 2cm;\n    margin-right: 1cm;\n}\n.logoWrapper img {\n   height: 100%;\n}\n.logoWrapper > img:nth-child(2){\n    height: 2.5cm;\n}\n\n.topSeparator {\n    border-top: 5px solid var(--psyellow);\n    height: 5px;\n    width: 17.8cm;\n    position: absolute;\n    margin-top: -1cm;\n    /* top: 34.7cm; */\n    z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
